import { Outlet, Link, useLocation } from 'react-router';
import { BookOpen, Gem, ListOrdered, ScrollText, Swords, Users } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { AppShell, type AppShellNavItem } from './AppShell';
import UserDropdown from './UserDropdown';

const PROJECT_NAME = 'ORC Sheet Builder';

// Новая оболочка главного раздела (M3) на базе AppShell.
// Содержимое страниц не трогаем — только обёртка/навигация.
export default function MainShell() {
  const location = useLocation();
  const t = useTranslation();
  const projectName = t('app.name', {}, PROJECT_NAME) || PROJECT_NAME;

  const isActive = (path: string) => {
    if (path === '/characters') {
      return location.pathname === '/' || location.pathname === '/characters';
    }
    return location.pathname.startsWith(path);
  };

  const navItems: AppShellNavItem[] = [
    {
      path: '/characters',
      label: t('navigation.myCharacters', {}, 'My Characters'),
      icon: <Users size={20} />,
      active: isActive('/characters'),
    },
    {
      path: '/knowledge',
      label: t('navigation.knowledgeBase', {}, 'Knowledge Base'),
      icon: <BookOpen size={20} />,
      active: isActive('/knowledge'),
    },
    {
      path: '/encounter-builder',
      label: t('navigation.encounterBuilder', {}, 'Encounter Builder'),
      icon: <Swords size={20} />,
      active: isActive('/encounter-builder'),
      separatorBefore: true,
    },
    {
      path: '/initiative-tracker',
      label: t('navigation.initiativeTracker', {}, 'Initiative Tracker'),
      icon: <ListOrdered size={20} />,
      active: isActive('/initiative-tracker'),
    },
    {
      path: '/treasure-planner',
      label: t('navigation.treasurePlanner', {}, 'Treasure Planner'),
      icon: <Gem size={20} />,
      active: isActive('/treasure-planner'),
    },
    {
      path: '/gm-help',
      label: t('navigation.gmHelp', {}, 'GM Help'),
      icon: <ScrollText size={20} />,
      active: isActive('/gm-help'),
    },
  ];

  const brand = (
    <Link to="/" className="app-shell__brand">
      <span className="app-shell__brand-icon">
        <Swords size={24} aria-hidden="true" />
      </span>
      <span className="app-shell__brand-text">{projectName}</span>
    </Link>
  );
  const railBrand = (
    <Link to="/" className="app-shell__rail-brand-link" title={projectName} aria-label={projectName}>
      <Swords size={24} aria-hidden="true" />
    </Link>
  );

  return (
    <AppShell>
      <AppShell.Sidebar
        items={navItems}
        brand={brand}
        railBrand={railBrand}
        userMenu={<UserDropdown variant="sidebar" />}
        railUserMenu={<UserDropdown variant="rail" />}
      />
      <AppShell.Content>
        <Outlet />
      </AppShell.Content>
    </AppShell>
  );
}
